<template>
  <collapse title="Phases" :defaultCollapse="false" v-if="display">
    <roundType @change="$emit('changeRoundType', $event)" />
    <groupType @change="$emit('changeGroupType', $event)" />
    <days @change="$emit('changeDay', $event)" />
  </collapse>
</template>

<script>
import Collapse from '@/components/tools/collapse/Collapse'

import Days from '@/components/sport/games/filters/day/Days'
import GroupType from '@/components/sport/games/filters/day/GroupType'
import RoundType from '@/components/sport/games/filters/day/RoundType'
export default {
  name: 'SportGamesFiltersDay',
  components: { Collapse, Days, GroupType, RoundType },
  computed: {
    display () {
      return this.$store.getters['Sport/RoundType/list'].length > 1 ||
         this.$store.getters['Sport/GroupType/list'].length > 1 ||
         this.$store.getters['Sport/Day/list'].length > 1
    }
  }
}
</script>
